module.exports = __webpack_public_path__ + "static/media/beer.35709488.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/beer.png
// module id = 86
// module chunks = 0